import useLoadable from "./loadable"

useLoadable.server = require("./server").default;

export default useLoadable;
